// Date: 11 Aug 2026
// Ref: Single-product-access users should never see the KB chooser -- they go
// straight to the one product their role grants (see uInfo.can_view_codenavigator
// / can_view_continuum, set by PersonalController::login / MsController::login).
// Returns the product key to auto-select, or "" when the chooser should still
// decide (user has both, or -- edge case -- neither).
export const getSingleAccessibleProduct = (info) => {
  const canViewCodeNavigator = !!info?.can_view_codenavigator;
  const canViewContinuum = !!info?.can_view_continuum;

  if (canViewCodeNavigator && !canViewContinuum) return "codeNavigator";
  if (canViewContinuum && !canViewCodeNavigator) return "continuum";
  return "";
};

export const hasBothProductAccess = (info) =>
  !!info?.can_view_codenavigator && !!info?.can_view_continuum;
